var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderBookAskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.0012 9C18.0012 13.9706 13.9718 18 9.00122 18C9.00083 12.375 9.00098 13.9706 9.00098 9C9.00098 4.02944 9.00098 6.1875 9.00122 0C13.9718 0 18.0012 4.02944 18.0012 9Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000728607 9C0.000728607 13.9706 4.03017 18 9.00073 18C9.00112 12.375 9.00098 13.9706 9.00098 9C9.00098 4.02944 9.00098 6.1875 9.00073 0C4.03017 0 0.000728607 4.02944 0.000728607 9Z",
    fill: "#4ECC79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderBookAskIcon);
export default __webpack_public_path__ + "static/media/order-book-ask-icon.f31d9902147ea6065c239d678ff2fa57.svg";
export { ForwardRef as ReactComponent };